import React from 'react';

import Tippy from '@tippyjs/react';

import { ia, iaRa } from 'lib/helpers/utility';

import { getProcedureName } from 'components/practice/charts/ClinicalNote/shared/CPTCodes/lib/helpers';

const TruncatedLabel = ({ text, className = '' }) => {
  return <span className={`min-w-0 truncate ${className}`}>{text}</span>;
};

const ProceduresCell = ({ data, node, procedureCodes }) => {
  const procedures = iaRa(data?.procedures);
  const finalProcedures =
    procedureCodes || procedures.map((procedure) => getProcedureName(procedure)).filter(Boolean);

  const [firstProcedure, ...restProcedures] = finalProcedures || [];

  if (!!node?.group) {
    return null;
  }

  return (
    <div className="flex h-full flex-row items-center justify-center">
      {firstProcedure && (
        <Tippy
          content={<span className="text-white">{firstProcedure}</span>}
          theme="dark"
          appendTo={() => document.body}>
          <div className="flex max-h-[20px] min-w-0 max-w-[160px] items-center rounded-[4px] border border-solid border-neutral-200 bg-neutral-100 p-1 text-xs text-neutral-900">
            <TruncatedLabel text={firstProcedure} />
          </div>
        </Tippy>
      )}

      {ia(restProcedures) && (
        <div className="ml-1">
          <Tippy
            className="custom-tooltip tippy-dark !rounded-md "
            allowHTML
            interactive
            appendTo={() => document.body}
            placement="right"
            offset={[0, 10]}
            content={
              <div className="flex-column p-2">
                {restProcedures?.map((procedure) => (
                  <div key={procedure} className="text-slate-50 m-1 rounded-md p-1">
                    {procedure}
                  </div>
                ))}
              </div>
            }>
            <div className="flex max-h-[20px] items-center rounded-[4px] border border-solid border-neutral-200 bg-neutral-100 p-1 text-xs text-neutral-900">
              +{restProcedures.length}
            </div>
          </Tippy>
        </div>
      )}
    </div>
  );
};

export default ProceduresCell;
